export const supportedLanguages = ['en', 'es', 'et'];
